export enum PAYMENT_PROCESSOR {
	ALL = "",
	INTERSWITCH = "INTERSWITCH",
	PAYSTACK = "PAYSTACK",
	MONNIFY = "MONNIFY",
	OKRA = "OKRA",
	NIP = "NIP",
}
